import { ToastType } from './../enums/toast-type.enum';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastMessage } from '../models/toast-message';
import Swal from 'sweetalert2';

@Injectable()
export class LocalService {

  private toastSubject = new BehaviorSubject(new ToastMessage());
  public toasts = this.toastSubject.asObservable();

  showToast(body: string, title: string = 'Notificación', toastType: ToastType = ToastType.Default) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      iconHtml: '<i class="fas fa-bullhorn"></i>',
      customClass: {
        popup: 'my-toast-'+toastType,
        timerProgressBar: 'toast-bar-'+toastType,
        icon: 'toast-icon'
      },
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });

    Toast.fire({
      text: body
    });
  }

  private updateNavbarSubject = new BehaviorSubject(false);
  public updateNavbar = this.updateNavbarSubject.asObservable();

  notifyHeaderUpdate(hasToUpdate: boolean) {
    this.updateNavbarSubject.next(hasToUpdate);
  }

  copyToClipboard(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
